module.exports = __webpack_public_path__ + "banquet/components/Navbar/images/nav_search.36957246e2f644e13a9bdcf251a2ad8d.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Navbar/images/nav_search.png
// module id = 1684
// module chunks = 1